import { TrialBalanceRow } from '@/renderer/types/accounting';
import React from 'react';
import { formatCurrencyValue } from './accountingReports';

interface TrialBalanceTableProps {
  rows: TrialBalanceRow[];
}

export function TrialBalanceTable({ rows }: TrialBalanceTableProps) {
  return (
    <div className="max-h-[560px] overflow-auto rounded-2xl border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="sticky top-0 bg-gray-50">
          <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
            <th className="px-4 py-3">Account</th>
            <th className="px-4 py-3">Type</th>
            <th className="px-4 py-3 text-right">Debits</th>
            <th className="px-4 py-3 text-right">Credits</th>
            <th className="px-4 py-3 text-right">Closing balance</th>
            <th className="px-4 py-3 text-right">Journals</th>
            <th className="px-4 py-3">Last activity</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {rows.map((row) => (
            <tr key={row.account_id} className="align-top">
              <td className="px-4 py-3">
                <p className="font-semibold text-gray-900">
                  {row.account_code} - {row.account_name}
                </p>
                <p className="mt-1 text-xs text-gray-500">
                  {row.account_subtype || 'No subtype'} · {row.normal_balance}{' '}
                  normal balance
                </p>
              </td>
              <td className="px-4 py-3 capitalize text-gray-600">
                {row.account_type}
              </td>
              <td className="px-4 py-3 text-right font-medium text-gray-700">
                {formatCurrencyValue(row.total_debits)}
              </td>
              <td className="px-4 py-3 text-right font-medium text-gray-700">
                {formatCurrencyValue(row.total_credits)}
              </td>
              <td className="px-4 py-3 text-right font-semibold text-gray-900">
                {formatCurrencyValue(row.closing_balance)}
              </td>
              <td className="px-4 py-3 text-right text-gray-600">
                {row.journal_entry_count.toLocaleString()}
              </td>
              <td className="px-4 py-3 text-gray-600">
                {row.last_entry_date || 'No activity'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
